import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { USER_ROLES } from '@shared/constant/shared.constant';
import { Router } from '@angular/router';
import { EncryptionStorageService } from '@core/services/encryption-storage.service';

@Component({
  selector: 'app-spot-count-update-success-modal',
  templateUrl: './spot-count-update-success-modal.component.html',
  styleUrls: ['./spot-count-update-success-modal.component.scss']
})
export class SpotCountUpdateSuccessModalComponent implements OnInit {
heading:string = '';
bodyText:string = '';
bookingId: string = '';
groupUserId: string = '';
assisstedListUrl:string = '';
userRoles = USER_ROLES;
isSpotUpdate:boolean = true;

constructor(
  private readonly config: DynamicDialogConfig,
  private readonly router: Router,
  private readonly ref: DynamicDialogRef,
  private readonly encryptStorage: EncryptionStorageService
){}

ngOnInit(): void {
  this.bookingId = this.config?.data?.bookingId;
  this.heading = this.config?.data?.heading;
  this.bodyText = this.config?.data?.bodyText;
  this.isSpotUpdate = this.config?.data?.isSpotUpdate;
}

  navigateToBookingDetailsScreen(): void {
    this.closeDialog();
    this.assistedListUrl();
    this.router.navigate(
      [this.assisstedListUrl],
      { queryParams: { id: this.bookingId } }
    );

  }
 
  assistedListUrl() {
    let roleName = this.encryptStorage.getItem('roleName');  
    let bookingDetailsPath = 'group-booking-details';

    switch (roleName) {
      case this.userRoles.SUPER_ADMIN:
        this.assisstedListUrl = `super-admin/${bookingDetailsPath}`;
        break;
      case this.userRoles.PARKING_MANAGER:
      case this.userRoles.PARKING_OWNER:
        this.assisstedListUrl = `manager/${bookingDetailsPath}`;
        break;
    }
  }

  closeDialog(): void {
    this.ref.close();
  }
  
}
